import request from '@/utils/request'

export function getSystemOverview() {
  return request({
    url: '/api/system/overview',
    method: 'get'
  })
}

export function getSystemUsers(params) {
  return request({
    url: '/api/system/users',
    method: 'get',
    params
  })
}

export function getSystemUser(id) {
  return request({
    url: `/api/system/users/${id}`,
    method: 'get'
  })
}

export function createSystemUser(data) {
  return request({
    url: '/api/system/users',
    method: 'post',
    data
  })
}

export function updateSystemUser(id, data) {
  return request({
    url: `/api/system/users/${id}`,
    method: 'put',
    data
  })
}

export function deleteSystemUser(id) {
  return request({
    url: `/api/system/users/${id}`,
    method: 'delete'
  })
}

export function updateSystemUserStatus(id, statusCode) {
  return request({
    url: `/api/system/users/${id}/status`,
    method: 'put',
    data: { statusCode }
  })
}

export function resetSystemUserPassword(id, password) {
  return request({
    url: `/api/system/users/${id}/reset-password`,
    method: 'post',
    data: { password }
  })
}

export function getSystemUserRoleIds(id) {
  return request({
    url: `/api/system/users/${id}/role-ids`,
    method: 'get'
  })
}

export function saveSystemUserRoles(id, ids) {
  return request({
    url: `/api/system/users/${id}/roles`,
    method: 'put',
    data: { ids }
  })
}

export function getSystemRoles(params) {
  return request({
    url: '/api/system/roles',
    method: 'get',
    params
  })
}

export function getSystemRoleOptions(params) {
  return request({
    url: '/api/system/roles/options',
    method: 'get',
    params
  })
}

export function getSystemRole(id) {
  return request({
    url: `/api/system/roles/${id}`,
    method: 'get'
  })
}

export function createSystemRole(data) {
  return request({
    url: '/api/system/roles',
    method: 'post',
    data
  })
}

export function updateSystemRole(id, data) {
  return request({
    url: `/api/system/roles/${id}`,
    method: 'put',
    data
  })
}

export function deleteSystemRole(id) {
  return request({
    url: `/api/system/roles/${id}`,
    method: 'delete'
  })
}

export function updateSystemRoleStatus(id, statusCode) {
  return request({
    url: `/api/system/roles/${id}/status`,
    method: 'put',
    data: { statusCode }
  })
}

export function getSystemRoleMenuIds(id) {
  return request({
    url: `/api/system/roles/${id}/menu-ids`,
    method: 'get'
  })
}

export function saveSystemRoleMenus(id, ids) {
  return request({
    url: `/api/system/roles/${id}/menus`,
    method: 'put',
    data: { ids }
  })
}

export function getSystemMenus() {
  return request({
    url: '/api/system/menus',
    method: 'get'
  })
}

export function getSystemMenuTree() {
  return request({
    url: '/api/system/menus/tree',
    method: 'get'
  })
}

export function getSystemMenu(id) {
  return request({
    url: `/api/system/menus/${id}`,
    method: 'get'
  })
}

export function createSystemMenu(data) {
  return request({
    url: '/api/system/menus',
    method: 'post',
    data
  })
}

export function updateSystemMenu(id, data) {
  return request({
    url: `/api/system/menus/${id}`,
    method: 'put',
    data
  })
}

export function deleteSystemMenu(id) {
  return request({
    url: `/api/system/menus/${id}`,
    method: 'delete'
  })
}
